import React, { useEffect } from 'react';
import LoadingManager from './LoadingManager';

import './Loader.scss';

type LoaderProps = {
    isLoading?: boolean;
};

export const Loader = (props: React.PropsWithChildren<LoaderProps>) => {
    const { isLoading = false, children } = props;

    useEffect(() => {
        if (!isLoading) return;

        const manager = LoadingManager.getInstance();
        manager.addLoader();

        return () => {
            manager.removeLoader();
        };
    }, [isLoading]);

    // Always render children - the global loader handles the animation
    return <>{children}</>;
};
